'use strict';
const angular = require('angular');

/*@ngInject*/
export function DbAdminService($resource) {
  return $resource('/api/db-admin/:collection/:id', {
    collection: '@collection',
    id: '@_id'
  },{
    update: {
      method: 'PUT',

    }
  });
}


export default angular.module('conduu.DBAdminService', [])
  .factory('DBAdminService', DbAdminService)
  .name;



// WEBPACK FOOTER //
// ./client/services/db-admin/db-admin.service.js